import { createContext, useContext } from "react";

import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import api from "../app/api";
import useAlert from "./useAlert";
import { DeleteAlert, UpdateAlert } from "../components/Swal Alert/index";

import {
  setRiskAssesment,
  addRiskAssesment,
  updateRiskAssesment,
  deleteRiskAssesment,
} from "../features/riskAssesment/slice";
import appContext from "../app/contextState/context";

const RiskAssesmentContext = createContext();

function RiskAssesmentState(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { collection } = useSelector((state) => state.riskAssesment);
  const { categories } = useSelector((state) => state.category);

  const { showAlert } = useAlert();

  // STATES
  const [questionTypes, setQuestionTypes] = useState();
  const { loading, setLoading } = useContext(appContext);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // New RiskAssesment State
  const [data, setData] = useState({
    title: "",
    riskAssesmentFrequency: "Daily",
    notificationFrequency: {
      times: [Date.now()],
      date: Date.now(),
      day: "",
    },
    questions: [],
    categoryID: categories[0]?._id,
  });
  const [question, setQuestion] = useState({
    question: "",
    type: "",
    hintText: "",
    options: [],
    yes: "",
    no: "",
    required: false,
  });

  const fetchRiskAssesments = async (params) => {
    setLoading("fetch");
    try {
      const response = await api.get(`/risk-assesment`, { params });
      dispatch(setRiskAssesment(response.data));
      setLoading(false);
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(message, "danger");
      setLoading(false);
    }
  };
  const fetchRiskAssesmentByCompanyId = async (id) => {
    setLoading(true);
    try {
      if (!id) return setLoading(false);
      const response = await api.get(`/risk-assesment/${id}`);
      dispatch(setRiskAssesment(response.data));
      setLoading(false);
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      setLoading(false);
      showAlert(message, "danger");
    }
  };
  const fetchQuestionTypes = async () => {
    setLoading(true);
    try {
      const response = await api.get("/risk-assesment/question/types");
      setQuestionTypes(response.data.questionTypes);
      setLoading(false);
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(message, "danger");
      setLoading(false);
    }
  };
  const onDublicateQuestiuon = (question, index) => {
    var questions = [...data.questions];
    if (index == undefined) {
      questions.push(question);
    } else {
      questions = [
        ...questions.slice(0, index + 1),
        question,
        ...questions.slice(index + 1),
      ];
    }

    setData({ ...data, questions });
  };
  const onAddQuestiuon = (
    e,
    sortIndex,
    setSortIndex,
    editIndex,
    setEditIndex
  ) => {
    e.preventDefault();
    var questions = [...data.questions];
    if (question.type == "Smart Threshold") {
      if (question.emails?.length < 1 || !question.emails) {
        showAlert("Please select email for Smart Threshold question", "danger")
        return
      }
      if (question.threshold?.length < 1 || !question.threshold) {
        showAlert("Please add threshold for Smart Threshold question", "danger")
        return
      }
    }
    if (editIndex || editIndex == 0) {
      questions.splice(editIndex, 1);
      setEditIndex(undefined);
    }
    if (sortIndex) {
      questions.splice(sortIndex - 1, 0, question);
      setSortIndex(questions.length + 1);
    } else {
      if (question.type == 'Risk Rating') {
        questions.push({ ...question, question: 'Likelihood', type: 'likelihood' })
        questions.push({ ...question, question: 'Severity', type: 'severity' })
      } else {
        questions.push(question);
      }
    }
    setData({ ...data, questions });
    setQuestion({
      question: "",
      type: "",
      hintText: "",
      options: [],
      yes: "",
      no: "",
      required: false,
    });
  };

  const newRiskAssesment = async () => {
    setLoading("new");
    try {
      const response = await api.post("/risk-assesment/new", { ...data });
      dispatch(addRiskAssesment(response.data));
      setLoading(false);
      setData({
        title: "",
        riskAssesmentFrequency: "Daily",
        notificationFrequency: "",
        questions: [],
        category: categories[0],
      });
      showAlert("New Risk Assessment added ", "success");
      navigate("/risk-assesments");
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(message, "danger");
      setLoading(false);
    }
  };
  const changeRiskAssesment = async (status) => {
    if (!(await UpdateAlert())) return;
    setLoading(status ? status : "update");
    try {
      await api.put(
        `/risk-assesment/update/${data._id}`,
        status ? { status } : data
      );
      setData({ ...data, status });
      dispatch(updateRiskAssesment({ ...data, status }));
      setLoading(false);
      showAlert(
        status
          ? `Risk Assessment Review: ${status}`
          : "Risk Assessment updated successfully",
        "success"
      );
      return true;
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      setLoading(false);
      showAlert(message, "danger");
      setLoading(false);
    }
  };
  const removeRiskAssesment = async (riskAssesment) => {
    if (!(await DeleteAlert())) return;
    setLoading("delete");
    try {
      const response = await api.delete(
        `/risk-assesment/delete/${riskAssesment ? riskAssesment._id : data._id}`
      );
      dispatch(deleteRiskAssesment(response.data));
      setLoading(false);
      if (!riskAssesment) navigate("/risk-assesments");
      showAlert("Risk Assessment removed successfully", "success");
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(message, "danger");
      setLoading(false);
    }
  };

  // Review
  const sendForReview = async () => {
    changeRiskAssesment("pending");
  };
  const approveReview = async () => {
    const allow = await changeRiskAssesment("approved");
    if (allow) newRiskAssesment();
  };
  const rejectReview = async () => {
    changeRiskAssesment("rejected");
  };
  return (
    <RiskAssesmentContext.Provider
      value={{
        categories,
        collection,
        page,
        limit,
        loading,
        data,
        question,
        questionTypes,
        setData,
        setQuestion,
        fetchRiskAssesments,
        fetchRiskAssesmentByCompanyId,
        fetchQuestionTypes,
        setPage,
        onAddQuestiuon,
        newRiskAssesment,
        changeRiskAssesment,
        removeRiskAssesment,
        sendForReview,
        approveReview,
        rejectReview,
        onDublicateQuestiuon,
        setLimit
      }}
    >
      {props.children}
    </RiskAssesmentContext.Provider>
  );
}
export { RiskAssesmentContext, RiskAssesmentState };
